import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { MsRecommendationProcessedResponse } from '../interfaces/msRecommendation';
import type { Recommendations } from '../interfaces/productRecommendation';

// ENGINES

export const frequentlyBoughtTogetherEngineName = 'FrequentlyBoughtTogether';

// ENGINE LIST

export const frequentlyBoughtTogetherEngineList = [
  frequentlyBoughtTogetherEngineName,
];

export const selectProductRecommendationConfigs = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): MsRecommendationProcessedResponse | undefined =>
  state.productDiscovery?.productRecommendation?.recommendationsConfig;

export const selectProductRecommendations = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): Recommendations | undefined =>
  state.productDiscovery?.productRecommendation?.recommendations;

export const selectProductRecommendationsFetchingState = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): boolean => !!state.productDiscovery?.productRecommendation?.fetching;
